<template lang="pug">
    article.concern
        .row
            .form-col.large-10
                validation-provider(rules="required" v-slot="{ errors }" :name="`${attr}_yesno`")
                  // need it to run validations
                  input.hidden(type="radio" v-model="checked")
                  .radio-switch
                    .radio-switch-label
                        .medical-radio-buttons
                            .field.radio-field.negative.no-uncheck(:class="{checked: checked}")
                                label.no-custom(@click="check(true)" :class="{error: errors[0]}")
                                    input.no-custom(type="radio" :checked="checked===true" required)
                                    .label-text {{t('app.general._yes')}}
                            .field.radio-field.positive.no-uncheck(:class="{checked: checked===false}")
                                label.no-custom(@click="check(false, true)" :class="{error: errors[0]}")
                                    input.no-custom(type="radio", :checked="checked===false" required)
                                    .label-text  {{t('app.general._no')}}
                        label.regular(v-html="placeholder")
            .form-col.large-14
                div(v-show="checked")
                    Field(
                        :attr="attr",
                        v-model="tmpValue"
                        :concern-placeholder="t(`helpers.placeholder.form_attribute_description.pleceholders.${attr}` , {defaultValue: t('app.account.custom_field.concern_text_area_placeholder')})"
                        @change="onChange"
                        :disabled="disabled"
                        :required="!!checked"
                    )
                .field(v-show="!checked")
                    WithRequired(:require="false", :text="t('helpers.placeholder.form_attribute_description.concerns._'+attr)", :cut_text="true", :length="70-8")
                    br

            .clearfix
</template>
<script>
import Field from "../../form_block/_field"
import WithRequired from '../../shared/_with_required'
export default {
  components: {Field, WithRequired},
  props: {
    attr:   {type: String, required: true},
    value:  {type: String, required: false}, //can be null
    filled: {type: Number, required: false}, //can be null
  },
  // when data has been fetched we copy existing values to the memory
  // after that on the page we manipulate with memory data
  emits: {
    change: {},
    input: {},
  },
  data(){
    return {
      checked: null,
      tmpValue: null,
    }
  },
  created(){
    const val = this.value
    this.tmpValue = val
    this.checked = (val==null) ? null : val.length > 0
    this.onChange()
  },
  computed: {
    disabled(){ return !this.state.current_reg.person_id },
    placeholder(){
      return this.t("helpers.placeholder.form_attribute."+this.attr, {defaultValue: this.titleize(this.$sanitize(this.attr))})
    },
  },
  watch: {
    value(){ // emulates watch on v-model:value
      const val = this.value
      this.tmpValue = val
      this.checked = (val==null) ? null : val.length > 0
      this.onChange()
    },
    checked(){ this.onChange() },
  },
  methods: {
    check(val,setEmpty=false){
      if (this.disabled) return

      if (setEmpty) this.tmpValue = ""
      this.checked = val
    },
    onChange(){
      this.$emit("input", this.tmpValue)
      this.$emit("change", this.tmpValue)
    },
  }
}
</script>
